import type { FactoryOptionDto } from '@api/machines'
import type { Options } from '@common/utils'

export type HandleOptionChangeFunctionProps = ({
  groupId,
  machineId,
  option,
  optionId,
  quotationId
}: HandleOptionChangeParamsProps) => void

export type HandleOptionChangeParamsProps = {
  groupId?: string[]
  machineId?: null | string
  option: Options
  optionId: number
  quotationId: string
}

export interface FactoryOptionDtoWithChecked extends FactoryOptionDto {
  checked: boolean
}

export type SetArchivedFits = React.Dispatch<
  React.SetStateAction<FactoryOptionDtoWithChecked[]>
>

export type SectionsErrorsProps = {
  serviceContract?: boolean
  transportOption: boolean
  warranty: boolean
}

export const SERVICE_CONTRACT_TYPES = {
  ARDUOUS: 'Arduous',
  NONE: 'None',
  STANDARD: 'Standard'
} as const

export type ServiceContractType =
  (typeof SERVICE_CONTRACT_TYPES)[keyof typeof SERVICE_CONTRACT_TYPES]

export type SetContractType = React.Dispatch<React.SetStateAction<string>>

export type SectionsErrorsType = {
  serviceContract?: boolean
  transportOption: boolean
  warranty: boolean
}

export type AddCustomFactoryFitFunctionProps = {
  isUpdating: boolean
  name?: string | null
  optionId?: number
  dnp?: number
}
